import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import styles from '../../styles/TestSeriesDetails.module.css';

export default function ScheduleTable({ tests }) {
    const [open, setOpen] = useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'auto',
    };

    const tableHeaderStyle = {
        textAlign: 'left',
        padding: '8px',
        backgroundColor: '#f2f2f2',
        fontSize: '18px',
        fontFamily: 'Poppins',
        border: '1px solid #ddd',
    };

    const tableCellStyle = {
        textAlign: 'left',
        padding: '8px',
        border: '1px solid #ddd',
        fontSize: '18px',
        fontFamily: 'Poppins',
        color: '#686262',
        whiteSpace: 'normal', // Allow text wrapping
    };

    const codeCellStyle = {
        ...tableCellStyle,
        wordBreak: 'break-word', // Ensure long text wraps properly
        minWidth: '100px', // Prevent excessive shrinking
        maxWidth: '150px', // Prevent excessive stretching
    };

    const dateTimeCellStyle = {
        ...tableCellStyle,
        minWidth: '160px',
        maxWidth: '180px',
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(date);
    };

    const formatTime = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        date.setHours(date.getHours() + 5);
        date.setMinutes(date.getMinutes() + 30);
        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    };

    return (
        <div>
            {tests.length > 0 ? (
                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={tableHeaderStyle}>Code</th>
                            <th style={tableHeaderStyle}>Test Name</th>
                            <th style={{ ...tableHeaderStyle, minWidth: '160px' }}>Date</th>
                            <th style={{ ...tableHeaderStyle, minWidth: '160px' }}>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tests.slice(0, 5).map((test, index) => (
                            <tr key={index}>
                                <td style={codeCellStyle}>{test.code}</td>
                                <td style={tableCellStyle}>{test.testName}</td>
                                <td style={dateTimeCellStyle}>{formatDate(test.startDate)}</td>
                                <td style={dateTimeCellStyle}>{formatTime(test.startDate)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <Typography sx={{ fontFamily: 'Poppins', fontSize: '18px', color: '#686262', textAlign: 'center' }}>
                    {'Schedule not found!'}
                </Typography>
            )}

            {tests.length > 5 && (
                <Button variant="outlined" onClick={handleClickOpen} className={styles.Rectangle39}>
                    Load More
                </Button>
            )}

            {/* Full-Screen Modal with Scrollable Content */}
            <Dialog open={open} onClose={handleClose} fullScreen={isFullScreen ? true : false} maxWidth="lg">
                <DialogTitle sx={{ fontFamily: 'Poppins', fontSize: '18px', color: '#686262' }}>
                    Test Series Schedules
                </DialogTitle>
                <DialogContent sx={{ overflowX: 'auto' }}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>Code</th>
                                <th style={tableHeaderStyle}>Test Name</th>
                                <th style={{ ...tableHeaderStyle, minWidth: '160px' }}>Date</th>
                                <th style={{ ...tableHeaderStyle, minWidth: '160px' }}>Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tests.map((test, index) => (
                                <tr key={index}>
                                    <td style={codeCellStyle}>{test.code}</td>
                                    <td style={tableCellStyle}>{test.testName}</td>
                                    <td style={dateTimeCellStyle}>{formatDate(test.startDate)}</td>
                                    <td style={dateTimeCellStyle}>{formatTime(test.startDate)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ fontFamily: 'Poppins', fontSize: '16px', color: '#686262', textTransform: 'none' }}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
